/**
 * @generated SignedSource<<c76b1b3b6e88315a5fc2e2de413f34db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleRoutineListItemContent_RoutineOccasion$data = {
  readonly deadlineAt: string | null;
  readonly startAt: string;
  readonly " $fragmentType": "WidgetTeamScheduleRoutineListItemContent_RoutineOccasion";
};
export type WidgetTeamScheduleRoutineListItemContent_RoutineOccasion$key = {
  readonly " $data"?: WidgetTeamScheduleRoutineListItemContent_RoutineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleRoutineListItemContent_RoutineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleRoutineListItemContent_RoutineOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadlineAt",
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "b3dc8fa3af66006af22bb079ff85229e";

export default node;
